import * as React from "react";
import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.351 14.5177C12.3177 14.5177 13.1499 13.835 13.3389 12.8868L14.5329 6.89595C14.6872 6.12147 14.3777 5.32785 13.7398 4.86234L8.9809 1.38961C8.26901 0.870129 7.30304 0.870129 6.59116 1.38961L1.83223 4.86234C1.19431 5.32785 0.884817 6.12147 1.03917 6.89595L2.23315 12.8868C2.42211 13.835 3.25433 14.5177 4.22109 14.5177L11.351 14.5177ZM9.06241 11.2276L11.3102 5.62315H9.83937C9.67817 5.62315 9.52067 5.67142 9.38715 5.76173C9.25363 5.85204 9.15021 5.98026 9.09021 6.12987L8.10243 8.59421L9.06241 11.2276ZM8.76969 11.8385H7.2996C7.13828 11.8385 6.98065 11.7902 6.84703 11.6998C6.7134 11.6095 6.60991 11.4811 6.54988 11.3314L4.26064 5.62364H5.73031C5.89183 5.62366 6.04964 5.67207 6.18339 5.76261C6.31715 5.85315 6.42071 5.98169 6.48073 6.13164L8.76969 11.8385Z"
    />
  </svg>
);
export default SVGComponent;
